/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_TrialInputs */

const da_billing_plan_trial = /** @type {(inputs: Billing_Plan_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøv`)
};

/** @type {(inputs: Billing_Plan_TrialInputs) => LocalizedString} */
const en_billing_plan_trial = da_billing_plan_trial;

/**

* @param {Billing_Plan_TrialInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_trial = /** @type {((inputs?: Billing_Plan_TrialInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_TrialInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_trial(inputs)
	return /** @type {LocalizedString} */ ("Prøv")
});